import {useEffect, useState} from "react";
import {InputBase, Typography} from "@mui/material";
import {UnitSystem} from "../../../../../api/Projects";
import {formatDim, parseDimension} from "./DimensionEditor";

// a one-line "caption + input" dimension field for dense places like the ribbon. The
// input shows the value in the project's unit system and commits on Enter or blur; an
// entry that does not parse is discarded and the field snaps back to the value.
export function DimensionField(props: {
    label: string;
    value: number;
    sys: UnitSystem;
    onChange: (value: number) => void;
}) {
    const [text, setText] = useState(formatDim(props.value, props.sys));

    useEffect(() => {
        setText(formatDim(props.value, props.sys));
    }, [props.value, props.sys]);

    const commit = () => {
        const parsed = parseDimension(text, props.sys);
        if(isNaN(parsed) || Math.abs(parsed - props.value) < 1e-6) {
            setText(formatDim(props.value, props.sys));
            return;
        }
        props.onChange(parsed);
    };

    return (
        <div style={{display: "flex", alignItems: "center", gap: 6}}>
            <Typography sx={{fontSize: 12, width: 64}}>{props.label}</Typography>
            <InputBase
                value={text}
                onChange={e => setText(e.currentTarget.value)}
                onFocus={e => e.currentTarget.select()}
                onBlur={commit}
                onKeyDown={e => {
                    if(e.key === "Enter") e.currentTarget.blur();
                    if(e.key === "Escape") {
                        setText(formatDim(props.value, props.sys));
                        e.currentTarget.blur();
                    }
                }}
                sx={{
                    width: 72,
                    fontSize: 13,
                    px: 0.75,
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 1,
                    "& input": {py: 0.25},
                }}
            />
        </div>
    );
}
